import { z } from 'zod';
/**
 * Hasznalati statisztika - a szerver es az admin felulet kozos szerzodese.
 *
 * Az audit naplo a rendszert erinto valtozasokat rogziti; ez azt, hogy a
 * kollegak MIT csinalnak. Tartalom soha, csak teny es darabszam.
 */
export const USAGE_KINDS = [
    'login',
    'session.connected',
    'session.closed',
    'message.sent',
    'reaction.added',
    'search.run',
    'file.uploaded',
    'huddle.joined',
    'huddle.left',
    'reminder.created',
    'list.item.created',
    'message.edited',
    'message.deleted',
    'message.pinned',
    'message.saved',
    'channel.created',
    'channel.joined',
    'dm.opened',
    'canvas.opened',
    'canvas.edited',
    'list.created',
    'transcript.viewed',
    'client.vitals',
    'phone.call',
    'channel.recap',
    /** Egy MCP-eszkoz hivasa szemelyes tokennel (M6). */
    'mcp.call',
];
/** Emberi cimke a fajtakhoz - az admin felulet ezt mutatja. */
export const USAGE_KIND_LABELS = {
    login: 'Belépés',
    'session.connected': 'Kapcsolódás',
    'session.closed': 'Kapcsolat bontva',
    'message.sent': 'Üzenet',
    'reaction.added': 'Reakció',
    'search.run': 'Keresés',
    'file.uploaded': 'Fájl',
    'huddle.joined': 'Hívás',
    'huddle.left': 'Hívás vége',
    'reminder.created': 'Emlékeztető',
    'list.item.created': 'Listaelem',
    'message.edited': 'Üzenet szerkesztve',
    'message.deleted': 'Üzenet törölve',
    'message.pinned': 'Kitűzés',
    'message.saved': 'Mentés későbbre',
    'channel.created': 'Csatorna létrehozva',
    'channel.joined': 'Csatlakozás csatornához',
    'dm.opened': 'DM nyitva',
    'canvas.opened': 'Canvas megnyitva',
    'canvas.edited': 'Canvas szerkesztve',
    'list.created': 'Lista létrehozva',
    'transcript.viewed': 'Átirat megnézve',
    'client.vitals': 'Sebességminta a kliensről',
    'phone.call': 'Telefonhívás',
    'channel.recap': 'Csatorna-összefoglaló',
    'mcp.call': 'MI-hívás (MCP)',
};
export const USAGE_CLIENTS = ['web', 'desktop', 'api'];
/** A fejlec, amivel a kliens megmondja, micsoda. Hianyzik = web. */
export const USAGE_CLIENT_HEADER = 'x-avslack-client';
/**
 * A felulet sebessege a kliens gepen - oldalbetoltesenkent egy minta.
 * Milliszekundum; a CLS aranyszam. Minden mezo opcionalis: amit a bongeszo
 * nem tud merni, az kimarad.
 */
export const clientVitalsInput = z.object({
    /** Time to first byte - a halozat es a proxy. */
    ttfbMs: z.number().int().min(0).max(120_000).optional(),
    /** Largest contentful paint - mikor latszik a lenyeg. */
    lcpMs: z.number().int().min(0).max(120_000).optional(),
    /** Interaction to next paint - mennyit kesik egy kattintas. */
    inpMs: z.number().int().min(0).max(60_000).optional(),
    /** Cumulative layout shift - ugral-e a felulet. */
    cls: z.number().min(0).max(10).optional(),
    /** Az uzenetlista elso megjelenese a betoltestol - a chat "kesz" pillanata. */
    firstMessagesMs: z.number().int().min(0).max(120_000).optional(),
});
export const usageStatsQuery = z.object({
    /** `all` = minden ceg (csak szuperadmin). Ures = a sajat ceg. */
    teamId: z.string().optional(),
    days: z.coerce.number().int().min(1).max(365).default(30),
});
//# sourceMappingURL=usage.js.map